<template>
  <quick-tips :tips="tips"/>
</template>

<script>
import QuickTips from '@/components/QuickTips.vue';

export default {
  components: {
    QuickTips,
  },
  data() {
    return {
      tips: [],
    };
  },
  created() {
    this.tips = [
      {
        body: [
          'A shared ID happens when two different people are assigned the same identifier.'
          + 'If an identifier is shared, one of the records should be split to a new master record and identifier.'
          + 'History records will need to be assigned to the corresponding master record.',
        ],
      },
      {
        header: 'ID to Split:',
        body: ['A valid and active identifier must be entered. The Person Record must have at least one Person History Record to perform a split.'],
      },
    ];
  },
};
</script>

<style lang="sass" scoped>
</style>
